'use client';

const ScrollButton = ({ buttonText, scrollTarget = '.scroll-target' }) => {
  const scrollToGetInTouchForm = () => {
    const element = document.querySelector(scrollTarget);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      type="button"
      className="flex min-h-[44px] w-56 cursor-pointer justify-center self-center rounded-full bg-brittainRed py-2 text-center font-lato text-xl font-extrabold tracking-widest text-white hover:scale-110 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-none lg:self-start lg:py-3"
      title="Scroll to Get In Touch Form"
      onClick={scrollToGetInTouchForm}
      aria-label="Scroll to Get In Touch Form"
    >
      {buttonText}
    </button>
  );
};

export default ScrollButton;
